// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as Graphql_ppx_runtime from "@illusionalsagacity/graphql-ppx/rescript-runtime/graphql_ppx_runtime.res.mjs";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as GameContentFragments$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/GameContentFragments.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyActivityQuery($locale: Locale!, $activityId: String!)  {\nacademy_query_activity(args: {activity_id: $activityId})  {\n__typename  \nacademyActivityId  \ncontentId  \nkind  \ncontentKind  \nacademyAttemptId  \nstudentAttemptId  \nnumComplete  \nnumCorrect  \nstate  \ncontentMd5  \nresponsesScore  \nbestAccuracy  \nbestResponsesAccuracy  \nhasResponsesScore  \ncontent(locale: $locale)  {\n__typename\n...on WordGameData   {\n...WordGameDataFragment   \n}\n\n...on ComprehensionPlaceholderData   {\n__typename  \nid  \n}\n\n...on VideoData   {\n...VideoDataFragment   \n}\n\n...on TupperwareData   {\n...TupperwareDataFragment   \n}\n\n...on WhackAMunkData   {\n...WhackAMunkDataFragment   \n}\n\n...on SoundTrainData   {\n...SoundTrainDataFragment   \n}\n\n...on MonsterChefData   {\n...MonsterChefDataFragment   \n}\n\n...on InternalStaticData   {\n...InternalStaticDataFragment   \n}\n\n...on UnsafeData   {\n...UnsafeDataFragment   \n}\n\n...on UnkownGameType   {\n__typename  \nerror  \n}\n\n}\n\n}\n\n}\n",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ], GameContentFragments$LiteracyplanetClientFlags.UnsafeDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.TupperwareDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.WordGameDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.WhackAMunkDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.VideoDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.MonsterChefDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.InternalStaticDataFragment.query, GameContentFragments$LiteracyplanetClientFlags.SoundTrainDataFragment.query);

function parse(value) {
  var value$1 = value.academy_query_activity;
  return {
          academy_query_activity: value$1.map(function (value) {
                var value$1 = value.academyAttemptId;
                var value$2 = value.studentAttemptId;
                var value$3 = value.state;
                var value$4 = value.contentMd5;
                var value$5 = value.responsesScore;
                var value$6 = value.bestAccuracy;
                var value$7 = value.bestResponsesAccuracy;
                var value$8 = value.hasResponsesScore;
                var value$9 = value.content;
                var typename = value$9["__typename"];
                var tmp;
                switch (typename) {
                  case "ComprehensionPlaceholderData" :
                      tmp = {
                        NAME: "ComprehensionPlaceholderData",
                        VAL: {
                          __typename: value$9.__typename,
                          id: value$9.id
                        }
                      };
                      break;
                  case "InternalStaticData" :
                      tmp = {
                        NAME: "InternalStaticData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.InternalStaticDataFragment.verifyArgsAndParse("InternalStaticDataFragment", value$9)
                      };
                      break;
                  case "MonsterChefData" :
                      tmp = {
                        NAME: "MonsterChefData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.MonsterChefDataFragment.verifyArgsAndParse("MonsterChefDataFragment", value$9)
                      };
                      break;
                  case "SoundTrainData" :
                      tmp = {
                        NAME: "SoundTrainData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.SoundTrainDataFragment.verifyArgsAndParse("SoundTrainDataFragment", value$9)
                      };
                      break;
                  case "TupperwareData" :
                      tmp = {
                        NAME: "TupperwareData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.TupperwareDataFragment.verifyArgsAndParse("TupperwareDataFragment", value$9)
                      };
                      break;
                  case "UnkownGameType" :
                      var value$10 = value$9.error;
                      tmp = {
                        NAME: "UnkownGameType",
                        VAL: {
                          __typename: value$9.__typename,
                          error: !(value$10 == null) ? value$10 : undefined
                        }
                      };
                      break;
                  case "UnsafeData" :
                      tmp = {
                        NAME: "UnsafeData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.UnsafeDataFragment.verifyArgsAndParse("UnsafeDataFragment", value$9)
                      };
                      break;
                  case "VideoData" :
                      tmp = {
                        NAME: "VideoData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.VideoDataFragment.verifyArgsAndParse("VideoDataFragment", value$9)
                      };
                      break;
                  case "WhackAMunkData" :
                      tmp = {
                        NAME: "WhackAMunkData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.WhackAMunkDataFragment.verifyArgsAndParse("WhackAMunkDataFragment", value$9)
                      };
                      break;
                  case "WordGameData" :
                      tmp = {
                        NAME: "WordGameData",
                        VAL: GameContentFragments$LiteracyplanetClientFlags.WordGameDataFragment.verifyArgsAndParse("WordGameDataFragment", value$9)
                      };
                      break;
                  default:
                    tmp = {
                      NAME: "FutureAddedValue",
                      VAL: value$9
                    };
                }
                return {
                        __typename: value.__typename,
                        academyActivityId: value.academyActivityId,
                        contentId: value.contentId,
                        kind: value.kind,
                        contentKind: value.contentKind,
                        academyAttemptId: !(value$1 == null) ? value$1 : undefined,
                        studentAttemptId: !(value$2 == null) ? value$2 : undefined,
                        numComplete: value.numComplete,
                        numCorrect: value.numCorrect,
                        state: !(value$3 == null) ? value$3 : undefined,
                        contentMd5: !(value$4 == null) ? value$4 : undefined,
                        responsesScore: !(value$5 == null) ? value$5 : undefined,
                        bestAccuracy: !(value$6 == null) ? value$6 : undefined,
                        bestResponsesAccuracy: !(value$7 == null) ? value$7 : undefined,
                        hasResponsesScore: !(value$8 == null) ? value$8 : undefined,
                        content: tmp
                      };
              })
        };
}

function serialize(value) {
  var value$1 = value.academy_query_activity;
  var academy_query_activity = value$1.map(function (value) {
        var value$1 = value.content;
        var variant = value$1.NAME;
        var content;
        if (variant === "ComprehensionPlaceholderData") {
          var value$2 = value$1.VAL.id;
          content = {
            __typename: "ComprehensionPlaceholderData",
            id: value$2
          };
        } else if (variant === "SoundTrainData") {
          content = Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.SoundTrainDataFragment.serialize(value$1.VAL), "SoundTrainData");
        } else if (variant === "TupperwareData") {
          content = Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.TupperwareDataFragment.serialize(value$1.VAL), "TupperwareData");
        } else if (variant === "FutureAddedValue") {
          content = value$1.VAL;
        } else if (variant === "VideoData") {
          content = Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.VideoDataFragment.serialize(value$1.VAL), "VideoData");
        } else if (variant === "UnsafeData") {
          content = Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.UnsafeDataFragment.serialize(value$1.VAL), "UnsafeData");
        } else if (variant === "UnkownGameType") {
          var value$3 = value$1.VAL.error;
          var error = value$3 !== undefined ? value$3 : null;
          content = {
            __typename: "UnkownGameType",
            error: error
          };
        } else {
          content = variant === "MonsterChefData" ? Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.MonsterChefDataFragment.serialize(value$1.VAL), "MonsterChefData") : (
              variant === "InternalStaticData" ? Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.InternalStaticDataFragment.serialize(value$1.VAL), "InternalStaticData") : (
                  variant === "WhackAMunkData" ? Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.WhackAMunkDataFragment.serialize(value$1.VAL), "WhackAMunkData") : Graphql_ppx_runtime.assign_typename(GameContentFragments$LiteracyplanetClientFlags.WordGameDataFragment.serialize(value$1.VAL), "WordGameData")
                )
            );
        }
        var value$4 = value.hasResponsesScore;
        var hasResponsesScore = value$4 !== undefined ? value$4 : null;
        var value$5 = value.bestResponsesAccuracy;
        var bestResponsesAccuracy = value$5 !== undefined ? value$5 : null;
        var value$6 = value.bestAccuracy;
        var bestAccuracy = value$6 !== undefined ? value$6 : null;
        var value$7 = value.responsesScore;
        var responsesScore = value$7 !== undefined ? value$7 : null;
        var value$8 = value.contentMd5;
        var contentMd5 = value$8 !== undefined ? value$8 : null;
        var value$9 = value.state;
        var state = value$9 !== undefined ? value$9 : null;
        var value$10 = value.numCorrect;
        var value$11 = value.numComplete;
        var value$12 = value.studentAttemptId;
        var studentAttemptId = value$12 !== undefined ? value$12 : null;
        var value$13 = value.academyAttemptId;
        var academyAttemptId = value$13 !== undefined ? value$13 : null;
        var value$14 = value.contentKind;
        var value$15 = value.kind;
        var value$16 = value.contentId;
        var value$17 = value.academyActivityId;
        var value$18 = value.__typename;
        return {
                __typename: value$18,
                academyActivityId: value$17,
                contentId: value$16,
                kind: value$15,
                contentKind: value$14,
                academyAttemptId: academyAttemptId,
                studentAttemptId: studentAttemptId,
                numComplete: value$11,
                numCorrect: value$10,
                state: state,
                contentMd5: contentMd5,
                responsesScore: responsesScore,
                bestAccuracy: bestAccuracy,
                bestResponsesAccuracy: bestResponsesAccuracy,
                hasResponsesScore: hasResponsesScore,
                content: content
              };
      });
  return {
          academy_query_activity: academy_query_activity
        };
}

function serializeVariables(inp) {
  var a = inp.locale;
  return {
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          activityId: inp.activityId
        };
}

function makeVariables(locale, activityId, param) {
  return {
          locale: locale,
          activityId: activityId
        };
}

var Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

function onLoading(param) {
  return "LoadingActivityContent";
}

function handleResponse(res) {
  return {
          TAG: "ActivityContentFound",
          _0: res
        };
}

function onResult(query) {
  return Belt_Result.map(query, handleResponse);
}

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function use$1(activityId) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  return Q.useWithErrorModal(onLoading, onLoading, onResult, {
              locale: locale,
              activityId: activityId
            });
}

var WordGameDataFragment;

var MonsterChefDataFragment;

var WhackAMunkDataFragment;

var SoundTrainDataFragment;

var TupperwareDataFragment;

var InternalStaticDataFragment;

var UnsafeDataFragment;

var VideoDataFragment;

export {
  WordGameDataFragment ,
  MonsterChefDataFragment ,
  WhackAMunkDataFragment ,
  SoundTrainDataFragment ,
  TupperwareDataFragment ,
  InternalStaticDataFragment ,
  UnsafeDataFragment ,
  VideoDataFragment ,
  Query ,
  onLoading ,
  handleResponse ,
  onResult ,
  Q ,
  use$1 as use,
}
/* query Not a pure module */
